module.exports = __webpack_public_path__ + "img/avatar_bg.251188a2.png";